import Axios from "axios";
import appUrl from "../../app/features/constants/appUrl";
import { axiosApi } from "../../app/features/constants/axios_api";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const payemntRequestSlice = createSlice({
    name: "payemntRequestSlice",
    initialState: {},
    reducers: {
        resetAddEditDeletePayments(state, action) {
            return { ...state, addSuccess: undefined, editSuccess: undefined, deleteSuccess: undefined };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPaymentRequestList.pending, (state, action) => {
                return { ...state, loading: true };
            })
            .addCase(getPaymentRequestList.fulfilled, (state, action) => {
                return {
                    ...state,
                    loading: false,
                    data: action.payload.data,
                    count: action.payload.count,
                };
            })
            .addCase(getPaymentRequestList.rejected, (state, action) => {
                return {
                    ...state,
                    loading: false,
                    error: action.payload,
                };
            });

        builder
            .addCase(uploadPaymentRequest.pending, (state, action) => {
                return { ...state, addLoading: true };
            })
            .addCase(uploadPaymentRequest.fulfilled, (state, action) => {
                return { ...state, addLoading: false, addData: action.payload, addSuccess: true };
            })
            .addCase(uploadPaymentRequest.rejected, (state, action) => {
                return {
                    ...state,
                    addLoading: false,
                    addError: action.payload,
                    addSuccess: false,
                };
            });
    },
});

export default payemntRequestSlice.reducer;
export const { resetAddEditDeletePayments } = payemntRequestSlice.actions;

// Thunks
export const getPaymentRequestList = createAsyncThunk("paymentRequest/fetch", async (body, { rejectWithValue, fulfillWithValue }) => {
    try {
        const { data } = await axiosApi.get(appUrl.baseUrl + appUrl.getPaymentRequestList + `/?page=${body?.page}&searchText=${body?.searchText}&status=${body?.status}`
        );
        console.log(data,"data payment request")
        return fulfillWithValue({ data: data.data, count: data.count });
    } catch (error) {
        throw rejectWithValue(error.response && error.response.data.msg ? error.response.data.msg : error.message);
    }
});
export const uploadPaymentRequest = createAsyncThunk("paymentRequest/add", async (body, { rejectWithValue, fulfillWithValue }) => {
    console.log(body,"body body")
    try {
        const { data } = await axiosApi.post(appUrl.baseUrl + appUrl.uploadPaymentRequest, body);
        console.log(data,"data add payment request")
        return fulfillWithValue(data.data);
    } catch (error) {
        throw rejectWithValue(error.response && error.response.data.msg ? error.response.data.msg : error.message);
    }
});